const SESSION_LOCAL_STORAGE_KEYS = [
  "useId",
  "userName",
  "userEmail",
  "access_token",
  "cacheData",
  "permissions",
  "roles",
];

export function clearSessionAndRedirectToLogin(): void {
  SESSION_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.setItem(key, ""));
  document.cookie = "accept_notification =; ";
  window.location.href = "/login";
}
